"use client";

import { Heading } from "@/components/ui/typography";

const taxData = [
  { country: "Company registration", rate: "25%" },
  { country: "United States", rate: "21%" },
  { country: "Australia", rate: "30%" },
  { country: "Germany", rate: "~30%" },
  { country: "France", rate: "25%" },
  { country: "Hong Kong (offshore profits)", rate: "0%", highlight: true },
  { country: "Hong Kong (local, first HK$2M)", rate: "8.25%", highlight: true },
];

export default function Compare({ heading = "How Hong Kong Compares to High-Tax Countries" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[60px] flex justify-center px-4">
      <div className="w-full max-w-[848px] flex flex-col items-center gap-[50px]">

        {/* HEADING */}
        <div className="flex flex-col items-center gap-6 text-center max-w-[568px]">
          <Heading as="h2" variant="sectionCentered">
            {heading}
          </Heading>
          <p className="text-white/70 text-[16px] leading-[24px] font-medium">
            Founders usually begin researching this after realising how much tax
            they&apos;re paying locally.
          </p>
        </div>

        {/* TABLE */}
        <div className="w-full max-w-[538px] rounded-[16px] overflow-hidden">
          
          {/* HEADER */}
          <div className="flex justify-between px-5 pb-2">
            <span className="font-cambo text-[20px] md:text-[24px] tracking-[-1px] text-white">
              Country
            </span>
            <span className="font-cambo text-[20px] md:text-[24px] tracking-[-1px] text-white">
              Corporate Tax Rate
            </span>
          </div>

          {/* ROWS */}
          <div className="flex flex-col">
            {taxData.map((item, index) => (
              <div
                key={index}
                className={`flex justify-between items-center px-5 py-5 border-b border-white/10 ${
                  item.highlight ? "bg-[#0f1218]" : ""
                }`}
              >
                <span className="text-white text-[16px] md:text-[18px]">
                  {item.country}
                </span>
                <span className="text-white text-[16px] md:text-[18px]">
                  {item.rate}
                </span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}